import {
  GET_TIERS,
  ADD_TIER,
  UPDATE_TIER,
  DELETE_TIER,
  TIERS_LOADING
} from '../actions/types';

const initialState = {
  tiers: [],
  loading: false
};

export default function tierReducer(state = initialState, action) {
  switch (action.type) {
    case TIERS_LOADING:
      return { ...state, loading: true };
    case GET_TIERS:
      return { ...state, tiers: action.payload, loading: false };
    case ADD_TIER:
      return { ...state, tiers: [...state.tiers, action.payload].sort((a, b) => a.xpRequired - b.xpRequired) };
    case UPDATE_TIER:
      return {
        ...state,
        tiers: state.tiers.map(t => t._id === action.payload._id ? action.payload : t).sort((a, b) => a.xpRequired - b.xpRequired)
      };
    case DELETE_TIER:
      return { ...state, tiers: state.tiers.filter(t => t._id !== action.payload) };
    default:
      return state;
  }
}
